// extracted by mini-css-extract-plugin
export default {"NewRulesetButtonContainer":"NewRulesetButton-module__NewRulesetButtonContainer--FkfcS","NewRulesetButtonMenuItemBox":"NewRulesetButton-module__NewRulesetButtonMenuItemBox--g1ALm"};